/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiContactMetaFromJSON, ApiContactMetaToJSON, } from './ApiContactMeta';
import { ApiLeadFromJSON, ApiLeadToJSON, } from './ApiLead';
import { ApiMediaFromJSON, ApiMediaToJSON, } from './ApiMedia';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiContactFromJSON(json) {
    return ApiContactFromJSONTyped(json, false);
}
export function ApiContactFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'csvUploadSessionId': !exists(json, 'csvUploadSessionId') ? undefined : json['csvUploadSessionId'],
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'industry': !exists(json, 'industry') ? undefined : json['industry'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'leads': !exists(json, 'leads') ? undefined : (json['leads'].map(ApiLeadFromJSON)),
        'media': !exists(json, 'media') ? undefined : (json['media'].map(ApiMediaFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : (json['meta'].map(ApiContactMetaFromJSON)),
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'position': !exists(json, 'position') ? undefined : json['position'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiContactToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'csvUploadSessionId': value.csvUploadSessionId,
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'email': value.email,
        'firstName': value.firstName,
        'id': value.id,
        'industry': value.industry,
        'lastName': value.lastName,
        'leads': value.leads === undefined ? undefined : (value.leads.map(ApiLeadToJSON)),
        'media': value.media === undefined ? undefined : (value.media.map(ApiMediaToJSON)),
        'meta': value.meta === undefined ? undefined : (value.meta.map(ApiContactMetaToJSON)),
        'phone': value.phone,
        'position': value.position,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
